// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RBulb__badge.fargo.marina.eluno.title.block,.RButtonAction.rocky.sulguni,.RButtonSimple.RModal__close.larishae.transparent.rocky{background-color:unset!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
